exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-selected > a, .tab-selected > button {\n  background-color: #eaeaea;\n  border-color: #b1afaf; }\n\n.inline-container > .row {\n  overflow-x: hidden;\n  white-space: nowrap; }\n\n.inline-tabs {\n  display: inline-block;\n  float: none;\n  background-color: #d2cfcf; }\n\n.tab-selected {\n  background-color: #23b7e5; }\n\n.left-chevron {\n  position: absolute;\n  left: 0;\n  top: 8px;\n  cursor: pointer; }\n\n.right-chevron {\n  position: absolute;\n  right: 0;\n  top: 8px;\n  cursor: pointer; }\n\n.tab-container .btn-default {\n  background-color: transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/tabs/tabs.component.scss
// module id = ../../../../../src/app/shared/tabs/tabs.component.scss
// module chunks = main